import * as R from 'ramda';
import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = (state) => state.imports;

const makeSelectImportList = () => createSelector(
  store,
  ({ importList }) => importList,
);

const makeSelectEmptyRow = () => createSelector(
  store,
  ({ emptyRow }) => emptyRow,
);

const makeSelectImportType = () => createSelector(
  store,
  ({ importType }) => importType,
);

const makeSelectSourceType = () => createSelector(
  store,
  ({ sourceType }) => sourceType,
);

const makeSelectRolesGuids = () => createSelector(
  store,
  ({ rolesGuids }) => rolesGuids,
);

const makeSelectConfigOptions = () => createSelector(
  store,
  ({ configOptions }) => configOptions,
);

const makeSelectConfigByImportType = () => createSelector(
  store,
  ({ importType, configOptions }) => R.pathOr({}, [importType], configOptions),
);

const makeSelectImportMappers = () => createSelector(
  store,
  ({ mappers, importType }) => R.pathOr([], [importType], mappers),
);

const makeSelectCleanExistentRates = () => createSelector(
  store,
  ({ cleanExistentRates }) => cleanExistentRates,
);

const makeSelectCleanExistentTrailers = () => createSelector(
  store,
  ({ cleanExistentTrailers }) => cleanExistentTrailers,
);

const makeSelectReplaceExistentCompensations = () => createSelector(
  store,
  ({ replaceExistentCompensations }) => replaceExistentCompensations,
);

const makeSelectContractGuid = () => createSelector(
  store,
  ({ contractGuid }) => contractGuid,
);

const makeSelectTrailerActivityListGuid = () => createSelector(
  store,
  ({ trailerActivityListGuid }) => trailerActivityListGuid,
);

const makeSelectGlobalErrors = () => createSelector(
  store,
  ({ globalErrors }) => globalErrors,
);

const makeSelectErrors = () => createSelector(
  store,
  ({ errors }) => errors,
);

export {
  makeSelectErrors,
  makeSelectEmptyRow,
  makeSelectSourceType,
  makeSelectImportType,
  makeSelectImportList,
  makeSelectRolesGuids,
  makeSelectGlobalErrors,
  makeSelectContractGuid,
  makeSelectConfigOptions,
  makeSelectImportMappers,
  makeSelectCleanExistentRates,
  makeSelectConfigByImportType,
  makeSelectCleanExistentTrailers,
  makeSelectTrailerActivityListGuid,
  makeSelectReplaceExistentCompensations,
};
